export default function GeneralHeroSection({title, blurb, imageURL, imageALT}) {

    return (
        <div className="">
            <div
                className="paragraph paragraph--type--ixm-blocks-hero-banner paragraph--view-mode--default hero-banner hero-banner__style-1 pt-4 pt-lg-6 bg-blue-50 bg-gray-200-trimmed"
                style={{ paddingBottom: 0, marginBottom: 0 }}>
                <div className="flex justify-center">

                    <div className="row justify-content-between align-items-center text-center">
                        <div className="mh-column col-12 z-1">
                            <h1 className="d-block w-100 fw-bold mb-5 d-flex align-items-center justify-content-center flex-wrap">
                                <span
                                    className="d-block position-relative w-100 px-lg-10"
                                    style={{ fontSize: "clamp(1.75rem, 7vw, 4.5rem)" }}
                                >
                                    {title}
                                </span>
                            </h1>
                            <div className="col-12 col-lg-6 mx-auto ">
                                <div>
                                    <p>{blurb}</p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center mt-3 flex-wrap gap-3 ">
                            </div>
                        </div>
                        <div className="col-12 mt-3 flex justify-center z-0" style={{ lineHeight: 0 }}>
                            <img className="img-fluid hero__image-1 w-100"
                                 src={imageURL}
                                 alt={imageALT}
                                 style={{ maxHeight: "60vh", objectFit: "cover", display: "block" }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}